const Common = {
  countDown: function () {
    let time = $(".flash-sale-countdown, .productDetail__flashSale");
    time.each(function () {
      let el = $(this),
        value = $(this).data("time");
      let countDownDate = new Date(value).getTime();
      let timeout = setInterval(function () {
        let now = new Date().getTime(),
          distance = countDownDate - now;
        let days = Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds = Math.floor((distance % (1000 * 60)) / 1000);
        el.find(".days, .productDetail__countdownNumber.days").html(days < 10 ? "0" + days : days);
        el.find(".hours, .productDetail__countdownNumber.hours").html(hours < 10 ? "0" + hours : hours);
        el.find(".minutes, .productDetail__countdownNumber.minutes").html(minutes < 10 ? "0" + minutes : minutes);
        el.find(".seconds, .productDetail__countdownNumber.seconds").html(seconds < 10 ? "0" + seconds : seconds);
        if (distance < 0) {
          clearInterval(timeout);
          el.closest(".ps-section, .productDetail__flashSale").hide();
        }
      }, 1000);
    });
  },

  productTabs: function () {
    const tabs = document.querySelector(".product-tabs");
    if (!tabs) return;

    const tabItems = tabs.querySelectorAll(".product-tabs__item");
    const tabLinks = tabs.querySelectorAll(".product-tabs__link");

    tabLinks.forEach((link, index) => {
      link.addEventListener("click", function (e) {
        tabItems.forEach((item) => item.classList.remove("product-tabs__item--active"));
        tabItems[index].classList.add("product-tabs__item--active");
        const targetId = this.getAttribute("href");

        if (targetId) {
          const allTabContents = document.querySelectorAll(".ps-tab");
          allTabContents.forEach((content) => content.classList.remove("active"));

          const targetContent = document.querySelector(targetId);
          if (targetContent) {
            targetContent.classList.add("active");
          }
        }
      });
    });
  },

  relatedProductsSlider: function () {
    const swiperContainer = document.querySelector(".related-products-swiper");
    if (!swiperContainer || typeof Swiper === "undefined") return;

    const prevBtn = document.querySelector(".related-products__nav-btn--prev");
    const nextBtn = document.querySelector(".related-products__nav-btn--next");

    const swiper = new Swiper(".related-products-swiper", {
      slidesPerView: 1.5,
      spaceBetween: 16,
      loop: false,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn,
      },
      breakpoints: {
        480: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        640: {
          slidesPerView: 2.5,
          spaceBetween: 20,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
        1200: {
          slidesPerView: 5,
          spaceBetween: 24,
        },
        1400: {
          slidesPerView: 6,
          spaceBetween: 24,
        },
      },
    });
  },
  handleSelect2: function () {
    if (!jQuery().select2) return;

    const select = $('select[data-init-select2="true"]');
    select.select2();
  },

  productAttributeDropdown: function () {
    const syncDropdown = ($dropdown) => {
      const $select = $dropdown.closest(".productDetail__dropdown").find("select");
      const value = $select.val() || "";
      const $selectedOption = $select.find("option:selected");
      const selectedTitle = $selectedOption.text().trim();
      const $toggle = $dropdown.find(".productDetail__customDropdownToggle");

      $dropdown.find(".productDetail__customDropdownOption").each(function () {
        const $option = $(this);
        const optionValue = String($option.data("value") ?? "");
        const $nativeOption = $select.find(`option[value="${optionValue}"]`);
        const isDisabled = $nativeOption.prop("disabled");

        $option
          .toggleClass("is-selected", optionValue === String(value))
          .toggleClass("is-disabled", isDisabled)
          .prop("disabled", isDisabled);
      });

      $toggle.find("strong").text(selectedTitle);
      $toggle.find("small").text(value ? $dropdown.find(`.productDetail__customDropdownOption[data-value="${value}"] small`).text().trim() : "Choose option");
      $dropdown.toggleClass("has-value", Boolean(value));
    };

    $(document)
      .off("click.attributeDropdown")
      .on("click.attributeDropdown", ".productDetail__customDropdownToggle", function () {
        const $dropdown = $(this).closest(".productDetail__customDropdown");
        const isOpen = $dropdown.hasClass("is-open");

        $(".productDetail__customDropdown").not($dropdown).removeClass("is-open").find(".productDetail__customDropdownToggle").attr("aria-expanded", "false");
        syncDropdown($dropdown);
        $dropdown.toggleClass("is-open", !isOpen);
        $(this).attr("aria-expanded", String(!isOpen));
      })
      .on("click.attributeDropdown", ".productDetail__customDropdownOption", function () {
        const $option = $(this);

        if ($option.prop("disabled")) {
          return;
        }

        const $dropdown = $option.closest(".productDetail__customDropdown");
        const $select = $dropdown.closest(".productDetail__dropdown").find("select");

        $select.val(String($option.data("value") ?? "")).trigger("change");
        syncDropdown($dropdown);
        $dropdown.removeClass("is-open").find(".productDetail__customDropdownToggle").attr("aria-expanded", "false");
      })
      .on("change.attributeDropdown", ".productDetail__dropdown select", function () {
        syncDropdown($(this).closest(".productDetail__dropdown").find(".productDetail__customDropdown"));
      })
      .on("click.attributeDropdown", function (event) {
        if (!$(event.target).closest(".productDetail__customDropdown").length) {
          $(".productDetail__customDropdown").removeClass("is-open").find(".productDetail__customDropdownToggle").attr("aria-expanded", "false");
        }
      });

    $(".productDetail__customDropdown").each(function () {
      syncDropdown($(this));
    });

    document.addEventListener("ecommerce.quick-view.initialized", function () {
      $(".productDetail__customDropdown").each(function () {
        syncDropdown($(this));
      });
    });
  },

  logoutConfirmation: function () {
    const modal = document.getElementById("logoutConfirmationModal");
    const cancelBtn = document.getElementById("logoutCancelBtn");

    if (!modal) return;

    const closeModal = () => {
      modal.classList.remove("is-active");
      setTimeout(() => {
        modal.style.display = "none";
        document.body.style.overflow = "";
      }, 300);
    };

    const handleLogoutClick = function (e) {
      e.preventDefault();
      e.stopPropagation();

      modal.style.display = "flex";
      setTimeout(() => {
        modal.classList.add("is-active");
      }, 10);

      document.body.style.overflow = "hidden";
    };

    const attachLogoutHandlers = () => {
      const logoutLinks = document.querySelectorAll(".js-logout-link");
      logoutLinks.forEach((link) => {
        link.removeEventListener("click", handleLogoutClick);
        link.addEventListener("click", handleLogoutClick);
      });
    };

    attachLogoutHandlers();

    const observer = new MutationObserver(() => {
      attachLogoutHandlers();
    });
    observer.observe(document.body, { childList: true, subtree: true });

    if (cancelBtn) {
      cancelBtn.addEventListener("click", closeModal);
    }

    const overlay = modal.querySelector(".logout-confirmation__overlay");
    if (overlay) {
      overlay.addEventListener("click", closeModal);
    }

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && modal.classList.contains("is-active")) {
        closeModal();
      }
    });
  },
  accountMobileMenuToggle: function () {
    const toggle = document.getElementById("mobileMenuToggle");
    const sidebar = document.getElementById("customerSidebar");

    if (toggle && sidebar) {
      toggle.addEventListener("click", function () {
        sidebar.classList.toggle("show");
        document.body.classList.toggle("sidebar-open");
      });

      sidebar.addEventListener("click", function (e) {
        if (e.target === sidebar) {
          sidebar.classList.remove("show");
          document.body.classList.remove("sidebar-open");
        }
      });

      const menuLinks = sidebar.querySelectorAll("a");
      menuLinks.forEach(function (link) {
        link.addEventListener("click", function () {
          sidebar.classList.remove("show");
          document.body.classList.remove("sidebar-open");
        });
      });
    }
  },

  scrollToTop: function () {
    const scrollBtn = document.getElementById("scrollToTop");

    if (!scrollBtn) return;

    const toggleScrollBtn = () => {
      if (window.pageYOffset > 300) {
        scrollBtn.classList.add("show");
      } else {
        scrollBtn.classList.remove("show");
      }
    };

    window.addEventListener("scroll", toggleScrollBtn);

    scrollBtn.addEventListener("click", function () {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });

    toggleScrollBtn();
  },

  orderTimelineDropdown: function () {
    const dropdownToggles = document.querySelectorAll(".show-timeline-dropdown");

    if (!dropdownToggles.length) return;

    dropdownToggles.forEach((toggle) => {
      toggle.addEventListener("click", function (e) {
        e.preventDefault();
        const targetId = this.getAttribute("data-target");
        const dropdown = document.querySelector(targetId);

        if (dropdown) {
          if (dropdown.style.display === "none" || !dropdown.style.display) {
            dropdown.style.display = "block";
          } else {
            dropdown.style.display = "none";
          }
        }
      });
    });
  },

  advertisementPopup: function () {
    const popup = document.getElementById("advertisementPopup");
    if (!popup) return;

    const STORAGE_KEY = "ballangk_ad_popup_" + (popup.dataset.popupId || "0") + "_closed_at";
    const intervalHours = parseInt(popup.dataset.intervalHours || "0", 10);
    const HIDE_DURATION_MS = intervalHours * 60 * 60 * 1000;

    let slider = null;
    const sliderEl = popup.querySelector(".advertisement-popup__swiper");

    const initSlider = () => {
      if (!sliderEl || slider || typeof Swiper === "undefined") return;

      const interval = parseInt(popup.dataset.slideInterval || "5", 10) || 5;

      slider = new Swiper(sliderEl, {
        loop: true,
        autoplay: {
          delay: interval * 1000,
          disableOnInteraction: false,
        },
        pagination: {
          el: popup.querySelector(".advertisement-popup__pagination"),
          clickable: true,
        },
      });
    };

    // Browsers may skip autoplay for videos rendered while the popup is hidden, so start them once it is shown.
    const playVideos = () => {
      popup.querySelectorAll("video").forEach((video) => {
        video.muted = true;
        const playing = video.play();
        if (playing && typeof playing.catch === "function") playing.catch(() => {});
      });
    };

    const closePopup = () => {
      popup.classList.remove("is-visible");
      document.body.style.overflow = "";
      popup.querySelectorAll("video").forEach((video) => video.pause());
      if (slider) slider.autoplay.stop();
      try {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
      } catch (e) {}
    };

    const showPopup = () => {
      popup.classList.add("is-visible");
      document.body.style.overflow = "hidden";
      initSlider();
      playVideos();
    };

    const shouldShow = () => {
      if (HIDE_DURATION_MS <= 0) return true;

      try {
        const closedAt = localStorage.getItem(STORAGE_KEY);
        if (!closedAt) return true;
        return Date.now() - parseInt(closedAt, 10) >= HIDE_DURATION_MS;
      } catch (e) {
        return true;
      }
    };

    const hiddenByLink = new URLSearchParams(window.location.search).has("hide_popup");

    if (!hiddenByLink && shouldShow()) {
      showPopup();

      const displayTime = parseInt(popup.dataset.displayTime || "0", 10);
      if (displayTime > 0) {
        setTimeout(closePopup, displayTime * 1000);
      }
    }

    popup.querySelectorAll('[data-dismiss="advertisement-popup"]').forEach((el) => {
      el.addEventListener("click", closePopup);
    });

    popup.querySelector(".advertisement-popup__close")?.addEventListener("click", closePopup);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && popup.classList.contains("is-visible")) {
        closePopup();
      }
    });
  },

  mobileVendorMenuToggle: function () {
    const toggle = document.getElementById("mobileVendorMenuToggle");
    const sidebar = document.getElementById("vendorSidebar");

    if (!toggle || !sidebar || toggle.dataset.binded) return;
    toggle.dataset.binded = "1";

    const closeSidebar = () => {
      sidebar.classList.remove("show");
      document.body.classList.remove("sidebar-open");
    };

    toggle.addEventListener("click", () => {
      sidebar.classList.toggle("show");
      document.body.classList.toggle("sidebar-open");
    });

    sidebar.addEventListener("click", (e) => {
      const link = e.target.closest("a");

      if (e.target === sidebar) {
        closeSidebar();
        return;
      }

      if (link && !link.hasAttribute("data-bs-toggle")) {
        closeSidebar();
      }
    });
  },
};

$(function () {
  Common.countDown();
  Common.productTabs();
  Common.relatedProductsSlider();
  Common.handleSelect2();
  Common.productAttributeDropdown();
  Common.logoutConfirmation();
  Common.accountMobileMenuToggle();
  Common.scrollToTop();
  Common.orderTimelineDropdown();
  Common.advertisementPopup();
  Common.mobileVendorMenuToggle();

  document.addEventListener("shortcode.loaded", function (event) {
    setTimeout(function () {
      Common.countDown();
      const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
      const tooltipList = [...tooltipTriggerList].map((tooltipTriggerEl) => new bootstrap.Tooltip(tooltipTriggerEl));
    }, 100);
  });
});
